import {Directive} from '@angular/core';


@Directive({
    selector: '[acParent]',
})
export class AcParentDirective {

}
